import React from 'react';

const SectionHeader = ({ 
  title, 
  subtitle, 
  description, 
  textAlign = "text-center",
  className = "" 
}) => {
  return (
    <div className={`section-header ${textAlign} ${className}`} data-aos="fade-up">
      {subtitle && <h6 className="section-subtitle">{subtitle}</h6>}
      <h2 className="section-title">{title}</h2>
      {description && <p className="section-description mb-5">{description}</p>}
    </div>
  );
};

export default SectionHeader;
